import { jsx as _jsx } from "react/jsx-runtime";
import { usePosition } from '../../hooks';
export default function Group(props) {
    const { x: oldX, y: oldY, children } = props;
    const { x, y } = usePosition({
        x: oldX,
        y: oldY,
    });
    return _jsx("g", Object.assign({ transform: `translate(${x}, ${y})` }, { children: children }), void 0);
}
//# sourceMappingURL=Group.js.map